import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addDoor, getSingleDoor, updateDoor } from '../../../actions/homeAction'

const DoorsAdd = () => {
  const [door, setDoor] = useState({
    door:'',
    doorAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {drUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleDoor(drUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleDoor = useSelector(state => state.home.singleDoor)?.response
const data = singleDoor

useEffect(() => {
  setDoor({
    door: data?.door,
    doorAr: data?.doorAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.door])

console.log("door", drUUID);
  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setDoor({...door, [name]:value})
  }
  
  
  const onSave = () => {
    if(dataEdit){
      const payload = {
        door:door.door,
        doorAr:door.doorAr,
        priority:door.priority,
        active: door.active,
        doorId: data.doorId
        }
        dispatch(updateDoor(payload))
      } else {
        dispatch(addDoor(door))
    }
  }

  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${door.door}` : "Add Door" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/Doors'>Door</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? `Edit ` : "Add Door" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Door Number</label>
								<div className='col-sm-9'>
									<input
										type='number'
										className='form-control'
										name='door'
										value={door.door}
										placeholder='Door Number'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Door Number Ar</label>
								<div className='col-sm-9'>
									<input
										type='number'
										className='form-control'
										name='doorAr'
										value={door.doorAr}
										placeholder='Door Number Ar'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={door.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={door?.status}
                    >
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> {dataEdit ? 'Update' : 'Add'}
							</button>
							<Link to={'/CarDetail/Doors'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default DoorsAdd